<template>
  <div>
    <loading v-if="loading"/>
    <div v-else>
      <h2 class="text-primary-dark seccion">
        Siniestro {{ siniestro.poliza.producto.ramo.nombre|lowercase }}
      </h2>
      <div class="text-center">
        <logo-cia :id="siniestro.poliza.compania.id" class="logo-cia-gr"/>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label class="label-ficha">Tomador</label>
          {{ siniestro.poliza.cliente.tomador }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Póliza</label>
          {{ siniestro.poliza.numPoliza }}
        </div>
      </div>
      <div class="row">
        <div :class="{ 'col-md-4': siniestro.referenciaCompania != null, 'col-md-8': siniestro.referenciaCompania == null }">
          <label class="label-ficha">Nº Siniestro</label>
          {{ siniestro.alias }}
        </div>
        <div class="col-md-2">
          <label class="label-ficha">Fecha</label>
          {{ siniestro.fechaSiniestro|fecha }}
        </div>
        <div class="col-md-2">
          <label class="label-ficha">F. Parte</label>
          {{ siniestro.fechaParte || siniestro.fechaCreacion | fecha }}
        </div>
        <div class="col-md-4" v-if="siniestro.referenciaCompania">
          <label class="label-ficha">Referencia Cía.</label>
          {{ siniestro.referenciaCompania }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="label-ficha">Riesgo</label>
          <span v-if="siniestro.poliza.producto.ramo.naturaleza == 1">
            {{ siniestro.riesgo.nombreCorto }} - {{ siniestro.riesgo.descripcion }}
          </span>
          <span v-else>
            {{ siniestro.riesgo.descripcion }}
          </span>
        </div>
        <div class="col-md-6">
          <label class="label-ficha">Estado</label>
          {{ siniestro.subestado.descripcion }}
        </div>
      </div>
      <div class="row" v-if="siniestro.causaSiniestralidad">
        <div class="col-md-12">
          <label class="label-ficha">Causa</label>
          {{ siniestro.causaSiniestralidad.descripcion }}
        </div>
      </div>
      <div class="row" v-if="siniestro.danos != '' && siniestro.danos">
        <div class="col-md-12">
          <label class="label-ficha">Daños</label>
          {{ siniestro.danos }}
        </div>
      </div>
      <div class="row" v-if="siniestro.lugar  != '' && siniestro.lugar">
        <div class="col-md-12">
          <label class="label-ficha">Lugar</label>
          {{ siniestro.lugar }}
        </div>
      </div>
      <div class="row" v-if="siniestro.motivo != '' && siniestro.motivo">
        <div class="col-md-12">
          <label class="label-ficha">Motivo</label>
          {{ siniestro.motivo }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="label-ficha">Descripción</label>
          {{ siniestro.descripcion }}
        </div>
      </div>
      <div class="row" v-if="siniestro.observaciones  != '' && siniestro.observaciones">
        <div class="col-md-12">
          <label class="label-ficha">Obervaciones</label>
          {{ siniestro.obserrvaciones }}
        </div>
      </div>
      <div class="row" v-if="siniestro.siniestroAsurnet">
        <div class="col-md-12">
          <label class="label-ficha">Persona de contacto</label>
          <div class="row">
            <div class="col-md-6">
              {{ siniestro.siniestroAsurnet.contactoNombre }} {{ siniestro.siniestroAsurnet.contactoApellidos }}
            </div>
            <div class="col-md-3">
              {{ siniestro.siniestroAsurnet.contactoTelefono }}
            </div>
            <div class="col-md-3">
              {{ siniestro.siniestroAsurnet.contactoEmail }}
            </div>
          </div>
        </div>
      </div>

      <ul class="nav nav-tabs mt-3 mb-3">
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'incidenciasCliente'), 'border-primary': (tabActive == 'incidenciasCliente'),'active': (tabActive == 'incidenciasCliente') }" 
            @click="selectTab('incidenciasCliente')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="comments"/> Notas</span>
            <font-awesome-icon icon="comments" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
          </a>
        </li>
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'documentos'), 'border-primary': (tabActive == 'documentos'),'active': (tabActive == 'documentos') }" 
            @click="selectTab('documentos')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="paperclip"/> Documentos</span>
            <font-awesome-icon icon="paperclip" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
      </ul>
      <div class="tab-content px-0">
        <div class="tab-pane" :class="{ 'show': (tabActive == 'incidenciasCliente'), 'active': (tabActive == 'incidenciasCliente') }">
          <incidencias-cliente :idObjeto="siniestro.id" tipoObjeto="13"/>
        </div>
        <div class="tab-pane" :class="{ 'show': (tabActive == 'documentos'), 'active': (tabActive == 'documentos') }">
          <documentos-item :idObjeto="siniestro.id" tipoObjeto="13"/>
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import DocumentosItem from '@/components/comunes/DocumentosItem'
import IncidenciasCliente from '@/components/comunes/IncidenciasCliente'
export default {
  data() {
    return {
      loading: true,
      siniestro: {},
      tabActive: 'incidenciasCliente'
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials'
    })
  },
  mounted() {
    if (this.siniestro && this.siniestro.id == this.$route.params.id) {
      this.loading = false;
    } else {
      this.siniestro = {};
    }
    this.getSiniestro(this.$route.params.id);
  },
  methods: {
    getSiniestro(id) {
      let grupos = [
        'siniestro.poliza',
        'siniestro.subestado',
        'siniestro.causaSiniestralidad',
        'siniestro.riesgo',
        'siniestro.siniestroAsurnet',
        'poliza.compania',
        'poliza.cliente',
        'poliza.producto',
        'producto.ramo'
      ];

      let params = {
        'idPoliza': id,
        'grupos': grupos.join(','),
        'page': 1
      };

      let url = this.urlBase + 'siniestros/' + id + '?' + util.objToQuery(params);

      this.$http.get(url).then(
          (response) => {
            this.siniestro = response.body;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            if (error.status === 401) {
              this.$router.push({name:'Login'});
            }
          }
      );
    },
    selectTab(tab) {
      this.tabActive = tab;
    }
  },
  components: {
    Loading,
    LogoCia,
    DocumentosItem,
    IncidenciasCliente
  }
}
</script>